import { Link } from 'react-router-dom';

export default function DailyContestCTA() {
  return (
    <section className="relative w-full h-[500px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20dramatic%20night%20city%20backdrop%20with%20soft%20amber%20and%20deep%20coral%20gradient%2C%20blurred%20neon%20lights%2C%20luxurious%20golden%20texture%2C%20cinematic%20depth%20of%20field%2C%20editorial%20photography%20quality%2C%20rich%20atmospheric%20warmth%2C%20elegant%20bokeh%20highlights%2C%20dramatic%20composition&width=1800&height=1200&seq=cta-contest-bg&orientation=landscape"
        alt="每日黑料大赛"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 text-center px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-3 md:mb-4 tracking-wide">
          每日黑料大赛
        </h2>
        <p className="text-white/70 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
          每天更新全网最新最炸的独家猛料
          <br />
          参与投票选出今日最劲爆的瓜王
        </p>
        <Link
          to="/category/mingxing-bagua"
          className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-foreground-950 text-white hover:bg-foreground-900 font-semibold text-sm md:text-base transition-all duration-300 whitespace-nowrap"
        >
          <span className="w-7 h-7 rounded-full bg-primary-500 flex items-center justify-center">
            <i className="ri-fire-line text-white text-xs"></i>
          </span>
          立即参与黑料大赛
          <i className="ri-arrow-right-up-line ml-1"></i>
        </Link>
      </div>
    </section>
  );
}